import { render, staticRenderFns } from "./BlogTopicEdit.vue?vue&type=template&id=3cc77803&"
import script from "./BlogTopicEdit.vue?vue&type=script&lang=js&"
export * from "./BlogTopicEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports